module.exports = __webpack_public_path__ + "img/success_vip@2x.695ce959.png";